import type PptxGenJS from '@meitu/js-to-pptx';
import { pxToInch } from '@/utils/unit-kit';
import type { IChartLayer, ISlide } from '@/version-types';
import { savePPTChart } from '../utils/ppt';
import { checkChartIsEmpty } from '../utils/render';
import { renderLayerContentToCanvas } from './render-to-canvas';

export const renderLayerToPPT = async (slide: ISlide, layer: IChartLayer, outFontFamilyArr?: string[]) => {
    if (!checkChartIsEmpty(layer)) {
        savePPTChart(layer, slide, outFontFamilyArr);
        return;
    }

    const { left, top, width, height, rotate } = layer;
    const options: PptxGenJS.ImageProps = {
        x: pxToInch(left),
        y: pxToInch(top),
        w: pxToInch(width),
        h: pxToInch(height),
        rotate: rotate > 0 ? rotate : 360 + rotate, // 0 - 360
    };

    const canvas = await renderLayerContentToCanvas(layer, false);
    options.data = canvas?.toDataURL() || '';

    slide.addImage(options);
};
